import { Stack } from '@mui/material';

import { Text } from 'common';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';

export function ReplyModeFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.existingConversationId"
        label="Existing Conversation ID"
        helperText="Provide the existing conversation ID to reply to"
      />
      <BlockValueTemplateField
        fieldName="config.firstMessage"
        label="Reply Message"
        helperText="Enter the message to send as a reply to the conversation"
      />
      <Text variant="subtitle2" bold>
        ⚠️ HIPAA Security Notice
      </Text>
      <Text variant="subtitle2">
        SMS communications are not encrypted or secure. DO NOT configure workflows that request,
        collect, or transmit PHI via SMS. <br></br> PHI includes: patient names, medical conditions,
        symptoms, medications, appointment details with providers, or any health-related
        information.
      </Text>
    </Stack>
  );
}
